/**
 * Where each crop sits within a search-result thumbnail.
 *
 * VTR embeds every indexed frame as three overlapping squares spanning the full
 * width — for a 16:9 frame each square is 9/16 of the width, at the left edge,
 * centred, and at the right edge. A hit reports which of them produced its score,
 * and the results grid outlines that square so "matched on the left" is something
 * you can see rather than a letter you have to decode.
 *
 * Kept out of the component so the arithmetic is testable on its own; getting it
 * wrong draws a box over the wrong third and nothing else goes visibly amiss.
 */

/** Square side as a fraction of frame width, for a 16:9 frame. */
export const CROP_WIDTH_FRACTION = 9 / 16;   // 0.5625

export const CROP_LABELS = {
  L: 'left of frame',
  C: 'centre of frame',
  R: 'right of frame',
};

/**
 * CSS positioning for the matched-crop outline, as percentages of the thumbnail.
 * Returns null when there is no crop to highlight (telemetry mode).
 */
export function cropHighlightStyle(crop) {
  if (!crop || !(crop in CROP_LABELS)) return null;

  const width = CROP_WIDTH_FRACTION;
  // L sits flush left, R flush right, C centred — matching worker/crops.py's
  // crop_boxes(), which places the three squares at x = 0, (W-S)/2 and W-S.
  const left = crop === 'L' ? 0 : crop === 'R' ? 1 - width : (1 - width) / 2;

  return {
    left: `${(left * 100).toFixed(4)}%`,
    width: `${(width * 100).toFixed(4)}%`,
  };
}

/** Human-readable description of which part of the frame matched. */
export function cropDescription(crop) {
  return CROP_LABELS[crop] || null;
}
